import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import {
  OperationAntiMoneyLaundering,
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };

    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<
      Omit<
        OperationAntiMoneyLaundering,
        'venteEnPresenceDesParties' | 'clientPresentAuMomentIdentification'
      >
    > = {
      rachatDelaiCourt: [
        _.isNil(parameters?.operationAntiMoneyLaundering?.rachatDelaiCourt)
          ? false
          : parameters?.operationAntiMoneyLaundering?.rachatDelaiCourt,
        Validators.required,
      ],
      periodeReflexionSoupcon: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.periodeReflexionSoupcon,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.periodeReflexionSoupcon,
        Validators.required,
      ],
      achatVenteDelaiCourtSansStrategie: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.achatVenteDelaiCourtSansStrategie,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.achatVenteDelaiCourtSansStrategie,
        Validators.required,
      ],
      fondsDestinationProvenanceTiers: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.fondsDestinationProvenanceTiers,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.fondsDestinationProvenanceTiers,
        Validators.required,
      ],
      usageFaculteRenonciation: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.usageFaculteRenonciation,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.usageFaculteRenonciation,
        Validators.required,
      ],
      rachatFrequentInexplique: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.rachatFrequentInexplique,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.rachatFrequentInexplique,
        Validators.required,
      ],
      demandeAvanceSansJustification: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.demandeAvanceSansJustification,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.demandeAvanceSansJustification,
        Validators.required,
      ],
      transfertFrequentContrat: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.transfertFrequentContrat,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.transfertFrequentContrat,
        Validators.required,
      ],
      souscripteurDifferentPayeur: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.souscripteurDifferentPayeur,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.souscripteurDifferentPayeur,
        Validators.required,
      ],
      ppeOuTiersSansLienDesigne: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.ppeOuTiersSansLienDesigne,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.ppeOuTiersSansLienDesigne,
        Validators.required,
      ],
      annulationSansJustificationAchatImmo: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.annulationSansJustificationAchatImmo,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.annulationSansJustificationAchatImmo,
        Validators.required,
      ],
      transactionMultipleSurPeriodeCourte: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.transactionMultipleSurPeriodeCourte,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.transactionMultipleSurPeriodeCourte,
        Validators.required,
      ],
      achatImmoPrixSousOuSurEvalue: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.achatImmoPrixSousOuSurEvalue,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.achatImmoPrixSousOuSurEvalue,
        Validators.required,
      ],
      creditGarantieBienEtranger: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.creditGarantieBienEtranger,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.creditGarantieBienEtranger,
        Validators.required,
      ],
      operationComplexeMontantInhabituellementEleve: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.operationComplexeMontantInhabituellementEleve,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.operationComplexeMontantInhabituellementEleve,
        Validators.required,
      ],
      operationFavoriseAnonymat: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.operationFavoriseAnonymat,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.operationFavoriseAnonymat,
        Validators.required,
      ],
      montantInadequationProfil: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.montantInadequationProfil,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.montantInadequationProfil,
        Validators.required,
      ],
      incoherenceOperationObjetSocialSociete: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.incoherenceOperationObjetSocialSociete,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.incoherenceOperationObjetSocialSociete,
        Validators.required,
      ],
      paiementParBanqueHorsResidenceClient: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.paiementParBanqueHorsResidenceClient,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.paiementParBanqueHorsResidenceClient,
        Validators.required,
      ],
      produitServiceSansLogiqueSituationClient: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.produitServiceSansLogiqueSituationClient,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering
              ?.produitServiceSansLogiqueSituationClient,
        Validators.required,
      ],
      paiementNonIdentifiable: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.paiementNonIdentifiable,
        )
          ? false
          : parameters?.operationAntiMoneyLaundering?.paiementNonIdentifiable,
        Validators.required,
      ],
    };
    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }

  extract() {
    const formValue = _.cloneDeep(this.form.value);
    return {
      operationAntiMoneyLaundering: {
        ...formValue,
      },
    };
  }
}
